/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const funds = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.25 15h-1M.75 15h1m0 0v-4.033c0-.258.209-.467.467-.467h1.566c.258 0 .467.209.467.467V15m-2.5 0h2.5m0 0h2.5m0 0V7.478c0-.258.209-.467.467-.467L8.75 7c.258 0 .467.209.467.467V15M6.75 15h2.467m0 0h2.533m0 0V8.002c0-.258.209-.467.467-.467h1.566c.258 0 .467.21.467.467V15m-2.5 0h2.5M12.2 1H15v2.8M15 1l-3.142 3.142a1.4 1.4 0 0 1-1.392.351l-3.552-.95a1.4 1.4 0 0 0-1.352.363l-3.629 3.63"
    />
  </svg>
)
export default funds
